import gql from 'graphql-tag';

export default gql`
  query getTrendingSearchForGuestUser {
    getTrendingSearchForGuestUser {
      trendingKeywords
      trendingProductSubCate {
        refId
        productId
        refName
        refImage
        category {
          id
          name
          parentNameLocal
        }
      }
      trendingProductBrand {
        refId
        productId
        refName
        refImage
        brand {
          id
          name
        }
      }
    }
  }
`;
